import { CommonModule } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
} from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenav, MatSidenavContainer } from "@angular/material/sidenav";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule, MatRowDef } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import {
  NgLabelTemplateDirective,
  NgOptionTemplateDirective,
  NgSelectComponent,
} from "@ng-select/ng-select";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import BusinessPartnerAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity";
import { BusinessPartnerScheduleService } from "./business-partner-schedule.service";
import {
  BusinessPartnerScheduleAttributes,
  ScheduleTypeEnum,
} from "@albatrosdeveloper/ave-models-package";
import { IUpdateBusinessPartnerSchedule } from "./interfaces/update-business-partner-schedule.interface";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AddBusinessPartnerScheduleComponent } from "./add-business-partner-schedule/add-business-partner-schedule.component";
import { getLocalHourFromUTC, getUTCHourFromLocal } from "app/utils/get-local-hour-from-utc";

@Component({
  selector: "app-business-partner-schedule-modal",
  styleUrl: "./business-partner-schedule.component.scss",
  templateUrl: "./business-partner-schedule.component.html",
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenav,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    MatSelectModule,
    MatTabsModule,
    NgxMatSelectSearchModule,
  ],
})
export class BusinessPartnerScheduleComponent implements OnInit {
  daysList: { day: string; value: number }[] = [
    { day: "LUNES", value: 1 },
    { day: "MARTES", value: 2 },
    { day: "MIÉRCOLES", value: 3 },
    { day: "JUEVES", value: 4 },
    { day: "VIERNES", value: 5 },
    { day: "SÁBADO", value: 6 },
    { day: "DOMINGO", value: 7 },
  ];

  displayedColumns: string[] = [
    "day",
    "hourStart",
    "hourEnd",
    "statusId",
    "actions",
  ];

  dataSource: BusinessPartnerScheduleAttributes[] = [];

  constructor(
    private readonly bpScheduleService: BusinessPartnerScheduleService,
    private readonly snackBar: MatSnackBar,
    private readonly dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: BusinessPartnerAttributes
  ) {}

  ngOnInit(): void {
    this.findByBusinessPartner();
  }

  findByBusinessPartner() {
    this.bpScheduleService
      .findByBusinessPartnerId(this.data.id, "DELIVERY" as ScheduleTypeEnum)
      .subscribe((data) => {
        this.dataSource = (data?.data ?? []).map((schedule) => {
          schedule.hourStart = getLocalHourFromUTC(schedule.hourStart);
          schedule.hourEnd = getLocalHourFromUTC(schedule.hourEnd);
          return schedule;
        });
      });
  }

  getDayName(day: number): string {
    return this.daysList.find((d) => d.value === day)?.day ?? "";
  }

  onStatusChange(
    event: boolean,
    schedule: BusinessPartnerScheduleAttributes
  ): void {
    const originalStatusId = schedule.statusId;
    const updatedStatusId = event ? 1 : 0;
    const dataToUpdate: IUpdateBusinessPartnerSchedule = {
      hourStart: getUTCHourFromLocal(schedule.hourStart),
      hourEnd: getUTCHourFromLocal(schedule.hourEnd),
      statusId: updatedStatusId,
    };
    this.bpScheduleService
      .update(String(schedule._id), dataToUpdate)
      .subscribe({
        next: () => {
          this.findByBusinessPartner();
        },
        error: () => {
          schedule.statusId = originalStatusId;
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
        },
      });
  }

  openAddBPScheduleModal(schedule?: BusinessPartnerScheduleAttributes): void {
    const dialogRef = this.dialog.open(AddBusinessPartnerScheduleComponent, {
      panelClass: ".form-modal",
      data: {
        businessPartnerMongoId: String(this.data._id),
        type: "DELIVERY" as ScheduleTypeEnum,
        schedule,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) this.findByBusinessPartner();
    });
  }

  openDeleteBPSchedule(schedule: BusinessPartnerScheduleAttributes): void {
    this.bpScheduleService.remove(String(schedule._id)).subscribe({
      next: () => {
        this.snackBar.open("Registro eliminado con éxito.", "Cerrar", {
          duration: 3000,
          verticalPosition: "top",
        });
        this.findByBusinessPartner();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al eliminar el registro.",
          "Cerrar",
          { duration: 3000, verticalPosition: "top" }
        );
      },
    });
  }
}
